import AddressDto from '@/models/CompanyAddresses/CompanyAddressDto';
import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import NoteDto from '@/models/Notes/NoteDto';

export default class CompanyDto extends BaseAgencyScopeEntityDto{
    status = 0;
    sequenceNumber = 0;
    registeredName = '';
    brandName = '';
    emailAddress = '';
    phoneNumber: string;
    website = '';
    taxNumber = '';    
    registrationNumber = '';
    biography = '';
    avatar = '';
    externalAccountingSystemId = '';
    notes: NoteDto[] = [];
}